import React, { Component } from 'react'
import { Router, Route, browserHistory } from 'react-router'
import { Provider } from 'mobx-react'

import stores from './stores'
import routes from './routes'

import AppContainer from './AppContainer'

const checkAuthenticated = (prevState, nextState, replace, callback) => {

  stores.auth.ensureAuthenticated()
    .then((loggedIn) => {

      const user = stores.auth.user
      let promise = Promise.resolve(true)

      if (user && user.id && user.museumId) {
        const museumPath = `/museum/${user.museumId}/edit`

        if (!user.isAdmin && nextState.location.pathname !== museumPath) {
          promise = stores.museum.load(user.museumId)
            .then(({ models }) => {
              if (models[0].isNew) {
                replace(`/museum/${user.museumId}/edit`)
                throw new Error('New Museum')
              }
            })
        }
      }

      promise.then(() => {
        let location = '/'
        // check if the path isn't login
        // that way we can apply specific logic
        // to display/render the path we want to
        if (nextState.location.pathname !== '/login') {
          if (!loggedIn) {
            location = '/login'
            replace(location)
          }
        }
        // If the user is already logged in, forward them to the homepage
        else if (loggedIn) {
          replace(location)
        }
      })
        .catch((ex) => {
          if (ex.message === 'New Museum') {
            return true
          }
          throw ex
        })
        .then(() => {
          callback()
        })

    })

}

const onEnter = (...args) => checkAuthenticated(null, ...args)

export default class App extends Component {

  render() {
    return (
      <Provider {...stores}>
        <Router history={browserHistory}>
          <Route
            onEnter={onEnter}
            onChange={checkAuthenticated}
            component={AppContainer}
          >
            {routes}
          </Route>
        </Router>
      </Provider>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App.js